import React, { Component } from 'react'

class Loading extends Component {
    render() {
        return (
            <div className="loading">
                <i className="mdi mdi-loading mdi-spin mdi-48px"></i>
            </div>
        )
    }
}

export default Loading
